import React, { useState } from 'react'
import OtpInput from 'react-otp-input'
import { useDispatch, useSelector } from 'react-redux'
import { getCurrency } from '../helpers/Functions'
import { confirmPaymentAction, recAndDeclinedAction } from '../redux/actions/FloatFinanceAction'
import PrimaryTheme from '../Themes/Primary'
import { Reducers } from '../Interfaces/Interfaces';
import { useSnackbar } from 'notistack'
export default function FloatRepaymentForm() {
    const { enqueueSnackbar } = useSnackbar();
    const alert = useSelector((state: Reducers) => state.alert);
    const recAndDecline = useSelector((state: any) => state.recAndDecline)
    const floatFinanceDetails = useSelector((state: any) => state.floatFinanceDetails)
    // console.log(recAndDecline)
    const dispatch = useDispatch()
    const [BankRequestPay, setBankRequestPay] = useState("Cash Repayment")
    const [floatDetails, setfloatDetails] = useState({
        pin: { otp: "" }
    })
    const [loader, setloader] = useState(false)

    const handleRecAndDec = (status: string, floatDetails: any) => {
        setfloatDetails({
            pin: { otp: "" }
        })
        setBankRequestPay(status)
    }

    const handleBack = () => {
        dispatch({
            type: 'ALERT_MODAL',
            payload: false
        });
    }

    const handlePin = (value: any) => {
        setfloatDetails({
            pin: { otp: value }
        })

        // console.log(value)

    }
    React.useEffect(() => {
        setloader(false)

        if (Object.entries(alert).length !== 0) {
            if (!alert.successful) {
                enqueueSnackbar(alert.message, { variant: "error" });
                dispatch({
                    type: 'ALERT',
                    payload: {}
                });

            }
            else {

                enqueueSnackbar(alert.message, { variant: "success" });
                dispatch({
                    type: 'ALERT',
                    payload: {}
                });
                dispatch({
                    type: "STATUS_ALERT",
                    payload: true
                });
            }
        }

    }, [dispatch, alert]);

    const handleConfirm = (confirmStatus: string) => {
        // dispatch({ type: "REC_STATUS", payload: "cash" })
        setloader(true)
        setfloatDetails({
            pin: { otp: "" }
        })
        if (BankRequestPay === "Cash Repayment") {
            let data =
            {
                "requestId": floatFinanceDetails.id,
                "paymentMode": 1,
                "transactionPin": floatDetails.pin.otp,
                confirmStatus
            }
            dispatch(confirmPaymentAction(data))


        } else {
            let data =
            {
                "requestId": floatFinanceDetails.id,
                "paymentMode": 2,
                "transactionPin": floatDetails.pin.otp,
                confirmStatus
            }
            dispatch(confirmPaymentAction(data))
        }
        // dispatch(recAndDeclinedAction(confirmStatus))

    }
    return (


        <div className="col-md-12 p-5 text-center modal__cover">
            <div className="col-md-12" >
                <span className="badge-pill p-3 d-block col-md-7 col-12 ml-auto mr-auto confirm__payment__title" style={{
                    background: PrimaryTheme.warn,
                    fontFamily: PrimaryTheme.fonts?.MediumFont,
                }}>Confirm Repayment</span>
            </div>

            <div className="form-group mt-4 text-left">

                <div style={{
                    width: "100%", paddingTop: "20px", textAlign: "center"
                }}><p>
                        <span style={{ marginRight: "20px" }}>Agent Name:</span>{floatFinanceDetails && floatFinanceDetails.agentName ? floatFinanceDetails.agentName : "--"}<br></br>
                        <span style={{ marginRight: "20px" }}> Agent Phone:</span>{floatFinanceDetails && floatFinanceDetails.phoneNumber ? floatFinanceDetails.phoneNumber : "--"}<br></br>

                    </p>
                    <h1 className="mb-5" style={{
                        fontFamily: PrimaryTheme.fonts?.MediumFont,
                        textTransform: "uppercase",
                        fontSize: PrimaryTheme.fontSizes?.title
                    }}>{floatFinanceDetails && floatFinanceDetails.amountRequested ? getCurrency(floatFinanceDetails.amountRequested) : "--"}</h1>

                </div>
                <div className="input-group mb-3 col-md-12 ml-auto mr-auto">
                    < div className="input-group-prepend w-50">
                        <button style={{
                            borderRadius: "20px 0 0 20px",
                            width: "100%",
                            paddingTop: "10px",
                            paddingBottom: "10px",
                            fontSize:PrimaryTheme.fontSizes?.normal,
                            background: BankRequestPay === "Cash Repayment" ? "#278456" : PrimaryTheme.white,
                            color: BankRequestPay === "Cash Repayment" ? PrimaryTheme.white : PrimaryTheme.dark,
                            border: BankRequestPay === "Cash Repayment" ? "none" : `1px solid ${PrimaryTheme.primary}`
                        }} onClick={() => handleRecAndDec("Cash Repayment", recAndDecline)}>Cash Repayment</button>
                    </div>

                    <div className="input-group-append w-50">
                        <button type="button" style={{
                            borderRadius: "0 20px 20px 0",
                            width: "100%",
                            fontSize:PrimaryTheme.fontSizes?.normal,
                            paddingTop: "10px",
                            paddingBottom: "10px",
                            background: BankRequestPay === "Bank Transfer" ? PrimaryTheme.danger : PrimaryTheme.white,
                            color: BankRequestPay === "Bank Transfer" ? PrimaryTheme.white : PrimaryTheme.dark,
                            border: BankRequestPay === "Bank Transfer" ? "none" : `1px solid ${PrimaryTheme.primary}`,

                        }} onClick={() => handleRecAndDec("Bank Transfer", recAndDecline)} >Bank Transfer</button>
                    </div>

                </div>
                <div className="row" style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "40px", marginBottom: "20px" }}>
                    <div className="col-11">
                        <label>Enter PIN</label>
                    </div>

                    <div className="col-11" style={{ display: "flex", justifyContent: "center", background: "#f4f7fc", borderRadius: "26px" }}>
                        <OtpInput numInputs={4}
                            value={floatDetails.pin.otp}
                            isInputNum
                            shouldAutoFocus

                            inputStyle={{
                                width: '45px',
                                height: '45px',
                                fontSize: '24px',
                                padding: 0,
                                textAlign: 'center',
                                borderRadius: 10,
                                border: "1px solid",
                                borderColor: PrimaryTheme.primary
                            }}
                            isInputSecure
                            onChange={(evt: any) => handlePin(evt)}
                            separator={<span className="mr-3">  </span>} />

                    </div>

                </div>
                <div style={{ display: "flex", justifyContent: "center" }}>
                    {
                        loader ? <span style={{
                            borderRadius: "20px 20px 20px 20px",
                            width: "50%",
                            paddingTop: "10px",
                            paddingBottom: "10px",
                            background: PrimaryTheme.primary,
                            color: PrimaryTheme.white,
                            border: "none",
                            textAlign: "center"

                        }}  >Please wait...</span> : floatDetails.pin.otp === "" ? <span style={{
                            borderRadius: "20px 20px 20px 20px",
                            width: "50%",
                            paddingTop: "10px",
                            paddingBottom: "10px",
                            background: PrimaryTheme.primary,
                            color: PrimaryTheme.white,
                            border: "none",
                            textAlign: "center"

                        }}  >Confirm</span> : <button type="button" style={{
                            borderRadius: "20px 20px 20px 20px",
                            width: "50%",
                            paddingTop: "10px",
                            paddingBottom: "10px",
                            background: PrimaryTheme.primary,
                            color: PrimaryTheme.white,
                            border: "none"

                        }} onClick={() => handleConfirm(recAndDecline.recStatus)}>Confirm</button>
                    }



                </div>
                <p className="col-12" style={{ textAlign: "center", marginTop: "20px", cursor: "pointer", color: "#818e94" }}>
                    <span onClick={handleBack}> Back</span>
                </p>
            </div>
        </div >






    )
}
